import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgConsideration = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 208 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M179.364 51.7425C191.061 33.7163 200.552 18.3791 207.736 2.79863C208.341 1.48575 207.374 0 205.929 0H2.07128C0.625567 0 -0.341216 1.48575 0.264126 2.79863C7.44797 18.3791 16.9386 33.7163 28.6361 51.7425C31.0192 55.415 33.4261 59.1908 35.8309 63.0544C36.1967 63.642 36.8395 64 37.5316 64H170.468C171.161 64 171.803 63.642 172.169 63.0544C174.574 59.1908 176.981 55.415 179.364 51.7425Z",
		fill: "#C7DFFC"
	})
});
export default SvgConsideration;
